module.exports = __webpack_public_path__ + "img/editar.5fb22b53.png";